import * as firebase from 'firebase/app';
import 'firebase/messaging';

let objappVersion = navigator.appVersion;
let objAgent = navigator.userAgent;
let objbrowserName = navigator.appName;
let objfullVersion = '' + parseFloat(navigator.appVersion);
let objBrMajorVersion = parseInt(navigator.appVersion, 10);
let objOffsetName, objOffsetVersion, ix;
// In Chrome
if ((objOffsetVersion = objAgent.indexOf('Chrome')) != -1 ) {
  objbrowserName = 'Chrome';
  objfullVersion = objAgent.substring(objOffsetVersion + 7);
} else if ((objOffsetVersion = objAgent.indexOf('MSIE')) != -1) { // In Microsoft internet explorer
  objbrowserName = 'Microsoft Internet Explorer';
  objfullVersion = objAgent.substring(objOffsetVersion + 5);
} else if ((objOffsetVersion = objAgent.indexOf('Firefox')) != -1) { // In Firefox
  objbrowserName = 'Firefox';
} else if ((objOffsetVersion=objAgent.indexOf('Safari')) != -1) { // In Safari
  objbrowserName = 'Safari';
  objfullVersion = objAgent.substring(objOffsetVersion+7);
  if ((objOffsetVersion = objAgent.indexOf('Version')) != -1)
    objfullVersion = objAgent.substring(objOffsetVersion + 8);
  // For other browser 'name/version' is at the end of userAgent
} else if ((objOffsetName=objAgent.lastIndexOf(' ') + 1) < (objOffsetVersion = objAgent.lastIndexOf('/'))) {
  objbrowserName = objAgent.substring(objOffsetName, objOffsetVersion);
  objfullVersion = objAgent.substring(objOffsetVersion + 1);
  if (objbrowserName.toLowerCase() == objbrowserName.toUpperCase())
    objbrowserName = navigator.appName;
}
// trimming the fullVersion string at semicolon/space if present
if ((ix = objfullVersion.indexOf(';')) != -1)
  objfullVersion = objfullVersion.substring(0, ix);
if ((ix = objfullVersion.indexOf(' ')) != -1)
  objfullVersion = objfullVersion.substring(0, ix);
objBrMajorVersion = parseInt('' + objfullVersion, 10);
if (isNaN(objBrMajorVersion)) {
  objfullVersion = '' + parseFloat(navigator.appVersion);
  objBrMajorVersion = parseInt(navigator.appVersion, 10);
}

console.log('Browser name:', objbrowserName);
console.log('Full version:', objfullVersion);
console.log('Major version:', objBrMajorVersion);
console.log('navigator.appName:', navigator.appName);
console.log('navigator.userAgent:', navigator.userAgent);

global.browserName = objbrowserName;

let getNotificationToken = () => {};
let onTokenRefresh = () => {};

if (objbrowserName !== 'Safari') {
  const firebaseConfig = {
    apiKey: 'AIzaSyC4YgPZGNhsVv0eYzLwwqPEXHEBWBpxgCE',
    authDomain: 'nimbus-tutoring-inc.firebaseapp.com',
    databaseURL: 'https://nimbus-tutoring-inc.firebaseio.com',
    projectId: 'nimbus-tutoring-inc',
    storageBucket: 'nimbus-tutoring-inc.appspot.com',
    messagingSenderId: '40840058932',
    appId: '1:40840058932:web:8a6ca89aefa7ff03',
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const messaging = firebase.messaging();
  messaging.usePublicVapidKey('BBUUgWKX8288HKm7qCV_K3n6npKvEamFqQ4KNv2Lsjw54IbA4CJeYKX1iR3o7T_JmvaW6wva1QvyGsAZvTnHb8Y');
  getNotificationToken = () => messaging.getToken();
  onTokenRefresh = cb => messaging.onTokenRefresh(cb());
  messaging.onMessage(payload => {
    // console.log('message received:', payload)
  });
}

export {
  getNotificationToken,
  onTokenRefresh,
};



// WEBPACK FOOTER //
// ./src/config/firebase.js